export default __webpack_public_path__ + "9c7f742102765e808e4f03a32e6b3d45.png";